// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import GridsGridsCopyGridButtonContainer from '../../containers/GridsCopyGridButtonContainer';
import ShareGrid from '../buttons/ShareGrid';

const StyledShareGrid = styled(ShareGrid)`
  margin: ${Target.__MOBILE__ ? '1em 0.6em 0' : '0em'};
  display: flex;
  align-items: center;
  justify-content: space-around;

  ${Target.__MOBILE__
    ? css`
        & button:nth-of-type(1) {
          margin-right: 1em;
        }
      `
    : undefined}
`;

const StyledGridsCopyGridButtonContainer = styled(GridsGridsCopyGridButtonContainer)`
  margin: 0 0 0 0.4em;
  width: 100%;
`;

type Props = {
  className?: string;
  gridReference: string;
};

const PublicShareAndCopyButtons = ({ gridReference, className }: Props) => (
  <StyledShareGrid gridReference={gridReference} isPublicGrid className={className}>
    <StyledGridsCopyGridButtonContainer gridReference={gridReference} isPublicGrid />
  </StyledShareGrid>
);

export default PublicShareAndCopyButtons;
